<script>
  import {onMount} from 'svelte';
  import {IMAGES} from '@/const/images';
  import {PATHS} from '@/const/paths';
  import {fixLink$} from '@/store/lang';
  import {innerWidth$} from '@/streams/window-inner-size';

  let homeLink = '';
  let offsetHeight = 0;

  $: homeLink = $fixLink$(PATHS.HOME.pathname);

  onMount(() => (document.body.style.height = '100%'));
</script>

<style>
  .user-view-content {
    min-width: 1200px;
    min-height: calc(100vh - 56px);
  }
  .user-view-left {
    flex: 1;
    min-height: 100%;
  }
  .user-view-right {
    flex: 1.5;
    padding-top: 68px;
    min-height: 100%;
    background: #fff;
    gap: 80px;
  }
  .copy-right {
    margin-bottom: 60px;
  }
  @media screen and (max-width: 640px) {
    .user-view-content {
      display: block;
      min-width: auto;
      min-height: 100vh;
      background: #fff;
    }
    .user-view-left {
      display: none;
    }
    .user-view-right {
      padding-top: 40px;
      min-height: 100vh;
    }
  }
</style>

<svelte:window bind:innerHeight={offsetHeight} />

<div class="user-view-content df">
  <div class="user-view-left pr B1">
    <slot name="left" />
  </div>
  <div class="user-view-right f1 df fdc jcsb B1">
    <slot name="right" />
    <div class="copy-right df aic jcc">
      <div class="f12 lh20 tc T3">Phemex, Trade Simple <br /> © Copyright 2025 Phemex All rights reserved</div>
    </div>
  </div>
</div>
